import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { devWarn } from "@/lib/logger";

const CustomerAuthContext = createContext(null);

export function CustomerAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    (async () => {
      // Android's captive-portal WebView can throw on localStorage access
      // entirely (not just return null) — treat that the same as "no token".
      let token = null;
      try { token = localStorage.getItem("nhp_customer_token"); } catch { /* storage blocked */ }
      if (!token) { setChecking(false); return; }
      try {
        const { data } = await api.get("/customer/me", { headers: { Authorization: `Bearer ${token}` } });
        setCustomer(data);
      } catch (e) {
        devWarn("[customer/me] session invalid, clearing token", e?.message);
        try { localStorage.removeItem("nhp_customer_token"); } catch { /* storage blocked */ }
      }
      finally { setChecking(false); }
    })();
  }, []);

  const login = (token, c) => {
    try { localStorage.setItem("nhp_customer_token", token); } catch { /* storage blocked — session still works via the httpOnly cookie */ }
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
    setCustomer(c);
  };
  const logout = async () => {
    try { await api.post("/customer/logout"); }
    catch (e) { devWarn("[customer/logout] server error, clearing local state", e?.message); }
    try { localStorage.removeItem("nhp_customer_token"); } catch { /* storage blocked */ }
    delete api.defaults.headers.common.Authorization;
    setCustomer(null);
  };

  return (
    <CustomerAuthContext.Provider value={{ customer, checking, login, logout }}>
      {children}
    </CustomerAuthContext.Provider>
  );
}
export const useCustomerAuth = () => useContext(CustomerAuthContext);
